import { __assign, __generator } from "tslib";
import { all, takeLatest, delay, call, select, put, race, take, takeEvery, } from 'redux-saga/effects';
import { withCursor, streamActions } from '../../Stream';
import { watchedGroupsStreamId, recommendedGroupsStreamId } from './constants';
import { fetchMoreWatchedGroups, fetchMoreRecommendedGroups, initialFetch, unrecommendGroup, togglePinGroup, toggleWatchGroup, initializeNetworkBar, markChannelAsRead, } from './actions';
import { normalize } from 'normalizr';
import { userListSchema, userSchema } from '../../redux/normalizr/schemas/user';
import { fetchGroups, doPinGroup, doUnpinGroup, doUnrecommendGroup, } from './xhr';
import { addNotification } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications';
import { getIsNetworkBarInitialized } from './selectors';
import { getDataEntityById } from '../../redux/entities';
import { putEntities } from '../../redux/entities/actions';
import { groupLeaveSuccess, groupJoinSuccess, } from '../../redux/groups/actions';
function processStreams(initData, content_type) {
    var fetchWatched, fetchRecommended, _a, items, entities, _b, items, entities;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return __generator(this, function (_m) {
        switch (_m.label) {
            case 0:
                fetchWatched = content_type !== 'recommended_groups';
                fetchRecommended = content_type !== 'watched_groups';
                if (!fetchWatched) return [3 /*break*/, 4];
                if (!(!initData || ((_c = initData.watchedGroups) === null || _c === void 0 ? void 0 : _c.errorCode))) return [3 /*break*/, 2];
                return [4 /*yield*/, put(withCursor.actions.fetchFailure({
                        streamId: watchedGroupsStreamId,
                        errorMsg: 'Failed to fetch groups',
                    }))];
            case 1:
                _m.sent();
                return [3 /*break*/, 4];
            case 2:
                _a = normalize((_e = (_d = initData.watchedGroups) === null || _d === void 0 ? void 0 : _d.groups) !== null && _e !== void 0 ? _e : [], userListSchema), items = _a.result, entities = _a.entities;
                return [4 /*yield*/, put(withCursor.actions.fetchSuccess({
                        streamId: watchedGroupsStreamId,
                        items: items,
                        entities: entities,
                        hasMore: !!((_f = initData.watchedGroups) === null || _f === void 0 ? void 0 : _f.hasMore),
                        cursor: (_g = initData.watchedGroups) === null || _g === void 0 ? void 0 : _g.cursor,
                    }))];
            case 3:
                _m.sent();
                _m.label = 4;
            case 4:
                if (!fetchRecommended) return [3 /*break*/, 8];
                if (!(!initData || ((_h = initData.recommendedGroups) === null || _h === void 0 ? void 0 : _h.errorCode))) return [3 /*break*/, 6];
                return [4 /*yield*/, put(withCursor.actions.fetchFailure({
                        streamId: recommendedGroupsStreamId,
                        errorMsg: 'Failed to fetch recommended groups',
                    }))];
            case 5:
                _m.sent();
                return [3 /*break*/, 8];
            case 6:
                _b = normalize((_k = (_j = initData.recommendedGroups) === null || _j === void 0 ? void 0 : _j.groups) !== null && _k !== void 0 ? _k : [], userListSchema), items = _b.result, entities = _b.entities;
                return [4 /*yield*/, put(withCursor.actions.fetchSuccess({
                        streamId: recommendedGroupsStreamId,
                        items: items,
                        entities: entities,
                        hasMore: false,
                        cursor: (_l = initData.recommendedGroups) === null || _l === void 0 ? void 0 : _l.cursor,
                    }))];
            case 7:
                _m.sent();
                _m.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function loadNetworkbarData(content_type, cursor) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(fetchGroups, content_type, cursor)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function resetStream(content_type) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(!content_type || content_type === 'watched_groups')) return [3 /*break*/, 3];
                return [4 /*yield*/, put(withCursor.actions.initialize({
                        streamId: watchedGroupsStreamId,
                        itemsPerFetch: 50,
                        hasMore: true,
                        fetchNextCallback: fetchMoreWatchedGroups,
                    }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(streamActions.markAsFetching(watchedGroupsStreamId))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!(!content_type || content_type === 'recommended_groups')) return [3 /*break*/, 6];
                return [4 /*yield*/, put(withCursor.actions.initialize({
                        streamId: recommendedGroupsStreamId,
                        itemsPerFetch: 3,
                        hasMore: true,
                        fetchNextCallback: fetchMoreRecommendedGroups,
                    }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(streamActions.markAsFetching(recommendedGroupsStreamId))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function handleFetchMoreWatchedGroups(_a) {
    var cursor, groups;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, delay(200)];
            case 1:
                _b.sent();
                return [4 /*yield*/, select(withCursor.selectors.getCursor, streamId)];
            case 2:
                cursor = _b.sent();
                return [4 /*yield*/, call(loadNetworkbarData, 'watched_groups', cursor)];
            case 3:
                groups = _b.sent();
                return [4 /*yield*/, call(processStreams, groups, 'watched_groups')];
            case 4:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleFetchMoreRecommendedGroups(_a) {
    var cursor, groups;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, delay(200)];
            case 1:
                _b.sent();
                return [4 /*yield*/, select(withCursor.selectors.getCursor, streamId)];
            case 2:
                cursor = _b.sent();
                return [4 /*yield*/, call(loadNetworkbarData, 'recommended_groups', cursor)];
            case 3:
                groups = _b.sent();
                return [4 /*yield*/, call(processStreams, groups, 'recommended_groups')];
            case 4:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleTogglePinGroup(_a) {
    var result, groups;
    var _b = _a.payload, groupId = _b.groupId, isPinnedAfter = _b.isPinnedAfter;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(isPinnedAfter ? doPinGroup : doUnpinGroup, groupId)];
            case 1:
                result = _c.sent();
                if (!(!result || !result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(addNotification(NotificationType.Generic, {
                        isError: true,
                        messageLocaleKey: isPinnedAfter
                            ? 'networkBar.errors.failedToPin'
                            : 'networkBar.errors.failedToUnpin',
                    }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(resetStream, 'watched_groups')];
            case 4:
                _c.sent();
                return [4 /*yield*/, call(loadNetworkbarData, 'watched_groups')];
            case 5:
                groups = _c.sent();
                return [4 /*yield*/, call(processStreams, groups, 'watched_groups')];
            case 6:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleUnrecommendGroup(_a) {
    var result, groups;
    var groupId = _a.payload.groupId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(doUnrecommendGroup, groupId)];
            case 1:
                result = _b.sent();
                if (!(!result || !result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(addNotification(NotificationType.Generic, {
                        isError: true,
                        messageLocaleKey: 'networkBar.errors.failedToUnrecommend',
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(resetStream, 'recommended_groups')];
            case 4:
                _b.sent();
                return [4 /*yield*/, call(loadNetworkbarData, 'recommended_groups')];
            case 5:
                groups = _b.sent();
                return [4 /*yield*/, call(processStreams, groups, 'recommended_groups')];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleToggleWatchGroup(_a) {
    var contentType, groups;
    var isWatchingAfter = _a.payload.isWatchingAfter;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                contentType = isWatchingAfter ? undefined : 'watched_groups';
                return [4 /*yield*/, call(resetStream, contentType)];
            case 1:
                _b.sent();
                return [4 /*yield*/, call(loadNetworkbarData, contentType)];
            case 2:
                groups = _b.sent();
                return [4 /*yield*/, call(processStreams, groups, contentType)];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleGroupMembershipChange() {
    var groups;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(resetStream)];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(loadNetworkbarData)];
            case 2:
                groups = _a.sent();
                return [4 /*yield*/, call(processStreams, groups)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleMarkChannelAsRead(_a) {
    var group;
    var _b, _c;
    var _d;
    var channel = _a.payload.channel;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, select(getDataEntityById, userSchema, channel)];
            case 1:
                group = _e.sent();
                if (!((_d = group === null || group === void 0 ? void 0 : group.networkbar) === null || _d === void 0 ? void 0 : _d.hasNewContent)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(putEntities({
                        entities: (_b = {},
                            _b[userSchema.key] = (_c = {},
                                _c[group.userId] = __assign(__assign({}, group), { networkbar: __assign(__assign({}, group.networkbar), { hasNewContent: false }) }),
                                _c),
                            _b),
                    }))];
            case 2:
                _e.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    var isInitialized, _a, needFetchFirst, alreadyFetched, initData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getIsNetworkBarInitialized)];
            case 1:
                isInitialized = _b.sent();
                if (!!isInitialized) return [3 /*break*/, 10];
                return [4 /*yield*/, call(resetStream)];
            case 2:
                _b.sent();
                return [4 /*yield*/, race({
                        needFetchFirst: take(initialFetch),
                        alreadyFetched: take(initializeNetworkBar),
                    })];
            case 3:
                _a = _b.sent(), needFetchFirst = _a.needFetchFirst, alreadyFetched = _a.alreadyFetched;
                if (!needFetchFirst) return [3 /*break*/, 8];
                return [4 /*yield*/, call(loadNetworkbarData)];
            case 4:
                initData = _b.sent();
                if (!initData) return [3 /*break*/, 6];
                return [4 /*yield*/, call(processStreams, initData)];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [4 /*yield*/, put(initializeNetworkBar(initData || {}))];
            case 7:
                _b.sent(); // init menu in store
                _b.label = 8;
            case 8:
                if (!alreadyFetched) return [3 /*break*/, 10];
                return [4 /*yield*/, call(processStreams, alreadyFetched.payload)];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [4 /*yield*/, all([
                    takeLatest(fetchMoreWatchedGroups, handleFetchMoreWatchedGroups),
                    takeLatest(fetchMoreRecommendedGroups, handleFetchMoreRecommendedGroups),
                    takeLatest(togglePinGroup, handleTogglePinGroup),
                    takeLatest(toggleWatchGroup, handleToggleWatchGroup),
                    takeLatest(unrecommendGroup, handleUnrecommendGroup),
                    takeEvery(markChannelAsRead, handleMarkChannelAsRead),
                    takeEvery([groupJoinSuccess, groupLeaveSuccess], handleGroupMembershipChange),
                ])];
            case 11:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map